module.exports = __webpack_public_path__ + "img/communicate.141ab2b3.png";